import "./Locations.module.css";
import Navigation from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import InteractiveMap from "./sections/InteractiveMap";
import Clinics from "./sections/Clinics";
import WeAreInTouch from "./sections/WeAreInTouch";
import SiteFooter from "@/reusable_sections/Footer";
export default function LocationsPage() {
  return <div>
      <Navigation />
      <Hero />
      <InteractiveMap />
      <Clinics />
      <WeAreInTouch />
      <SiteFooter />
    </div>;
}